import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../../services/api';
import { FaCheckCircle, FaClock, FaTimesCircle } from 'react-icons/fa';
import { formatLocalDateTime } from '../../utils/formatters';

/**
 * 支付历史组件
 */
export function PaymentHistory() {
  const { t, i18n } = useTranslation();
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPayments();
  }, []);

  const loadPayments = async () => {
    try {
      const data = await api.getPaymentHistory();
      if (data.code === 'SUCCESS') {
        setPayments(data.data.payments);
      }
    } catch (err) {
      console.error('Failed to load payments:', err);
    }
    setLoading(false);
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'completed':
        return <FaCheckCircle className="text-positive" />;
      case 'pending':
        return <FaClock className="text-accent-warm" />;
      case 'failed':
        return <FaTimesCircle className="text-negative" />;
      default:
        return null;
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'completed':
        return t('payment.completed');
      case 'pending':
        return t('payment.pending');
      case 'failed':
        return t('payment.failed');
      case 'refunded':
        return t('payment.refunded');
      default:
        return status || '-';
    }
  };

  const formatDate = (dateStr) => {
    return formatLocalDateTime(dateStr, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }, i18n.language);
  };

  if (loading) {
    return (
      <div className="flex justify-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-accent-strong"></div>
      </div>
    );
  }

  if (payments.length === 0) {
    return (
      <div className="text-center py-8 text-gray-400">
        {t('payment.noRecords')}
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {payments.map((payment) => (
        <div
          key={payment.id}
          className="bg-surface-highlight/50 rounded-lg p-4 flex items-center justify-between"
        >
          <div className="flex items-center gap-4">
            {getStatusIcon(payment.status)}
            <div>
              <div className="text-white font-medium">
                {t(`membership.${payment.tier_name || 'free'}`, (payment.tier_name || 'free').toUpperCase())} {t('payment.membershipLabel')}
                <span className="text-gray-400 text-sm ml-2">
                  {payment.period_months === 12 ? t('membership.yearly') : t('membership.monthly')}
                </span>
              </div>
              <div className="text-gray-400 text-sm">
                {formatDate(payment.created_at)}
              </div>
            </div>
          </div>

          <div className="text-right">
            <div className="text-white font-medium">
              ${payment.amount} {payment.currency}
            </div>
            <div className="text-sm text-gray-400">
              {getStatusText(payment.status)}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
